
<div mat-dialog-content class="w-full bg-white !p-0 !m-0">
  <div class="card-wrapper type-modal" [formGroup]="newUserForm">
    <div class="card">
      <h3 class="green decoration mb-4">Detalles del usuario</h3>

      <div class="form-wrapper mb-3" [class.control-invalid]="newUserForm.get('first_name').dirty && newUserForm.get('first_name').invalid">
        <span>Nombres:</span>
        <input type="text" formControlName="first_name" placeholder="Ej: Sergio Miguel" [attr.disabled]="true">
        <p *ngIf="newUserForm.get('first_name').dirty && newUserForm.get('first_name').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="newUserForm.get('first_name').errors.required">Este campo es necesario</label>
        </p>
      </div>
      <div class="form-wrapper mb-3" [class.control-invalid]="newUserForm.get('email').touched && newUserForm.get('email').invalid">
        <span>Correo electrónico:</span>
        <input type="email" formControlName="email" placeholder="Ej: ejemplo@email.com" [attr.disabled]="true">
        <p *ngIf="newUserForm.get('email').touched && newUserForm.get('email').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="newUserForm.get('email').errors.required">Este campo es necesario</label>
          <label *ngIf="newUserForm.get('email').errors.required && newUserForm.get('email').errors.email">,</label>
          <label *ngIf="newUserForm.get('email').errors.email">Este campo no es valido</label>
        </p>
      </div>
      <div class="form-wrapper mb-3" [class.control-invalid]="newUserForm.get('username').dirty && newUserForm.get('username').invalid">
        <span>Nombre de usuario:</span>
        <input type="text" formControlName="username" placeholder="Ej: SerMora254" [attr.disabled]="true">
        <p *ngIf="newUserForm.get('username').dirty && newUserForm.get('username').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="newUserForm.get('username').errors.required">Este campo es necesario</label>
        </p>
      </div>
    </div>
    <div class="card">
      <h3 class="green" style="margin-bottom: 1.6rem;">&nbsp;</h3>
      <div class="form-wrapper mb-3" [class.control-invalid]="newUserForm.get('last_name').dirty && newUserForm.get('last_name').invalid">
        <span>Apellidos:</span>
        <input type="text" formControlName="last_name" placeholder="Ej: Luján Mora" [attr.disabled]="true">
        <p *ngIf="newUserForm.get('last_name').dirty && newUserForm.get('last_name').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="newUserForm.get('last_name').errors.required">Este campo es necesario</label>
        </p>
      </div>
      <div class="form-wrapper mb-3" [class.control-invalid]="newUserForm.get('cellphone').dirty && newUserForm.get('cellphone').invalid">
        <span>Teléfono:</span>
        <input type="number" formControlName="cellphone" placeholder="Ej: 61234789" [attr.disabled]="true">
        <p *ngIf="newUserForm.get('cellphone').dirty && newUserForm.get('cellphone').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="newUserForm.get('cellphone').errors.required">Este campo es necesario</label>
        </p>
      </div>
      <div class="form-wrapper mb-3" [class.control-invalid]="newUserForm.get('role').dirty && newUserForm.get('role').invalid">
        <span>Rol:</span>
          <mat-select formControlName="role" placeholder="Seleccione una opción" multiple [attr.disabled]="true" [disabled]="true">
              <!-- <mat-option value="">Seleccione una opción</mat-option> -->
              <mat-option *ngFor="let role of roles" [value]="role.role_id">{{ role.display_name }}</mat-option>
          </mat-select>

        <p *ngIf="newUserForm.get('role').dirty && newUserForm.get('role').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="newUserForm.get('role').errors.required">Este campo es necesario</label>
        </p>
      </div>
      <!-- <div class="form-wrapper mb-3" [class.control-invalid]="newUserForm.get('gender').dirty && newUserForm.get('gender').invalid">
        <span>Genero:</span>
        <select formControlName="gender" [attr.disabled]="true">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let gender of genders" [value]="gender.value">{{ gender.name }}</option>
        </select>
        <p *ngIf="newUserForm.get('gender').dirty && newUserForm.get('gender').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="newUserForm.get('gender').errors.required">Este campo es necesario</label>
        </p>
      </div>
      <div class="form-wrapper mb-3" [class.control-invalid]="newUserForm.get('ci').dirty && newUserForm.get('ci').invalid">
        <span>CI:</span>
        <input type="number" formControlName="ci" placeholder="Ej: 22134459" [attr.disabled]="true">
        <p *ngIf="newUserForm.get('ci').dirty && newUserForm.get('ci').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="newUserForm.get('ci').errors.required">Este campo es necesario</label>
        </p>
      </div>
      <div class="form-wrapper mb-3" [class.control-invalid]="newUserForm.get('status').dirty && newUserForm.get('status').invalid">
        <span>Estado:</span>
        <select formControlName="status" [attr.disabled]="true">
          <option value="">Seleccione una opción</option>
          <option *ngFor="let userStatus of userStatuses" [value]="userStatus.value">{{ userStatus.name }}</option>
        </select>
        <p *ngIf="newUserForm.get('status').dirty && newUserForm.get('status').invalid">
          <img src="../../../assets/img/x-circle.svg" alt="icon">
          <label *ngIf="newUserForm.get('status').errors.required">Este campo es necesario</label>
        </p>
      </div> -->
    </div>
  </div>
</div>

<div mat-dialog-actions class="!m-0 w-full block">
  <div class="w-full flex justify-end actions_modal">
        <!-- <button cdkFocusInitial mat-button class="!hidden">Autofocus disabled</button> -->
        <!-- <button mat-button type="button" (click)="dismiss()" class="btn btn-gray big">Cancelar</button> -->
        <button mat-button type="button" (click)="dismiss()" class="btn btn-primary big">Aceptar</button>
  </div>
</div>
